module.exports = __webpack_public_path__ + "img/IC_Ausencia_Rechazada.07be6655.svg";